import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import EmailAppResource from './EmailAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';
import PhoneAppResource from './PhoneAppResource';
import ServiceTicketAppResource from './ServiceTicketAppResource';
import UserAppResource from './UserAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';

class ContactAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Contact';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'contacts';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'organizationUuid',
            'details',
            'fullName',
            'firstName',
            'lastName',
            'displayName',
            'middleName',
            'genderType',
            'user',
            'organization',
            'workspaceOrganizationMembers',
            'organizationMembers',
            'emails',
            'phones',
            'addresses',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
            organization: OrganizationAppResource,
            workspaceOrganizationMembers: WorkspaceOrganizationMemberAppResource,
            organizationMembers: OrganizationMemberAppResource,
            emails: EmailAppResource,
            phones: PhoneAppResource,
            addresses: AddressAppResource,
            serviceTickets: ServiceTicketAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
            organization: 'organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
            },
            details: {
                type: 'string',
            },
            fullName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            displayName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            middleName: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            genderType: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            emails: {
                type: 'array'
            },
            phones: {
                type: 'array'
            },
            addresses: {
                type: 'array'
            },
        };
    }

}

export default ContactAppResource;
